import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import { useLimpieza } from '../../../../../../hooks/useLimpieza'
import { TabLimpiezaModel } from '../../../../../../models'
import { CreationCleaningActivitiesForm } from '../form/creation-cleaning-activities'
import { TableSchedulesByActivityWrapper } from '../table/schedules'
const CreationCleaningActivitiesTab = () => {
  const { currentTabItem, changeCurrentTabItem, isAllowed } = useLimpieza()
  console.log('currentTabItem', currentTabItem)
  const handleBack = () => {
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}
      {/* <ButtonClose onClick={handleBack} color='#283897' /> */}
      <Tabs
        className={'sdx_sub_react_tab_panel '}
        selectedIndex={currentTabItem.currentExternalTab ?? 0}
        onSelect={(index) => {
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            currentExternalTab: index,
          }
          changeCurrentTabItem(obj)
        }}
      >
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          <Tab className={'sdx_sub_tab_panel_option'}>Programaciones</Tab>
        </TabList>
        <TabPanel>
          <CreationCleaningActivitiesForm />
        </TabPanel>
        <TabPanel>
          <TableSchedulesByActivityWrapper />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default CreationCleaningActivitiesTab
